import { db } from 'config/firebase'
import { doc, getDoc } from 'firebase/firestore'
import { getDownloadURL, getStorage, listAll, ref } from '@firebase/storage'
import { useQuery } from '@tanstack/react-query'
import { VehiclePhoto } from '@otw/models'

const storage = getStorage()

const getAdditionalPhotosForInventoryObject = async (
  collectionName: string,
  inventoryObjectId: string,
  definedInventoryPhotos: VehiclePhoto[],
): Promise<VehiclePhoto[]> => {
  const storageRef = ref(storage, `${collectionName}/${inventoryObjectId}`)

  const photos: VehiclePhoto[] = []

  const storageObjects = await listAll(storageRef)

  for (const obj of storageObjects.items) {
    const url = await getDownloadURL(obj)

    if (definedInventoryPhotos.some(photo => photo.url === url)) {
      continue
    } else {
      photos.push({
        id: inventoryObjectId,
        name: obj.name,
        fullPath: obj.fullPath,
        url,
      })
    }
  }
  return photos
}

const fetchPhotosForInventoryObject = async (collectionName: string, inventoryObjectId: string): Promise<VehiclePhoto[]> => {
  const inventoryDocRef = doc(db, collectionName, inventoryObjectId)
  console.count("Fetching")
  const docSnap = await getDoc(inventoryDocRef)
  const definedPhotos: VehiclePhoto[] = []

  if (!docSnap.exists()) {
    console.error('No such document!')
    return []
  }
 
  const data = docSnap.data() 

  if (!data) {
    console.error('No data found for document!')
    return []
  }

  const errorPhotos: unknown[] = []

  if (data.photos) {
    const photos: Record<string, string> = data.photos;
    for (const [key, value] of Object.entries(photos)) {
      try {
        const storageRef = ref(storage, `${collectionName}/${inventoryObjectId}/${value}`)

        if (!storageRef) {
          continue
        }

        const url = await getDownloadURL(storageRef)

        definedPhotos.push({
          id: inventoryObjectId,
          name: value,
          url: url,
          position: key,
          fullPath: ''
        })
      } catch (error) {
        console.error('Error getting download URL for photo', value, error)
        errorPhotos.push(value)
      }
    }
  }

  const additionalPhotos = await getAdditionalPhotosForInventoryObject(collectionName, inventoryObjectId, definedPhotos)

  return [...definedPhotos, ...additionalPhotos]
}

export const usePhotosForInventoryObject = (collectionName: string, inventoryObjectId: string) => {
  return useQuery({
    queryKey: ['photos', collectionName, inventoryObjectId],
    queryFn: () => fetchPhotosForInventoryObject(collectionName, inventoryObjectId),
    enabled: !!collectionName && !!inventoryObjectId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false
  })
}
// Keep the old function for backwards compatibility

